import { render, staticRenderFns } from "./AddSales.vue?vue&type=template&id=1dd0fd28&"
import script from "./AddSales.vue?vue&type=script&lang=js&"
export * from "./AddSales.vue?vue&type=script&lang=js&"
import style0 from "./AddSales.vue?vue&type=style&index=0&id=1dd0fd28&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports